
export enum AlertReasonCategory {
  Unauthorized = 1,
  Unusual = 2,
  Device = 3,
  Forbidden = 4,
  NewLogon = 5
}
